/**
 * Given an array, returns a random item within the array.
 * @param arr the array to sample.
 * @returns a random elemnt wtihin arr.
 */
export default function sample<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
